import { Swiper, Navigation } from 'swiper';

window.addEventListener('load', () => {
  function refreshTabindex() {
    const disabledLinks = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-active) a');
    disabledLinks.forEach((link) => {
      link.tabIndex = -1;
    });

    const activeLinks = this.el.querySelectorAll('.swiper-slide-active a');
    activeLinks.forEach((link) => {
      link.tabIndex = 0;
    });
  }

  new Swiper('.testimonials__swiper-container.swiper', {
    modules: [Navigation],
    speed: 700,
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      enabled: true,
    },
    navigation: {
      nextEl: '.testimonials__nav--next',
      prevEl: '.testimonials__nav--prev',
    },
    autoHeight: true,
    on: {
      init() {
        refreshTabindex.call(this);
      },
      slideChangeTransitionEnd() {
        refreshTabindex.call(this);
      },
    },
  });
});
